module.exports = __webpack_public_path__ + "images/emoji/wc.49257ddb6c823f5467d5.png";